import { createContext, useContext, ReactNode } from "react";

import domainConfig, { DomainMode } from "config/domainConfig";

interface DomainContextType {
  /** Current domain mode */
  mode: DomainMode;
  /** Whether to show prices */
  showPrices: boolean;
  /** Whether this is the reseller domain */
  isReseller: boolean;
  /** Get translation key with domain suffix if needed */
  getTranslationKey: (key: string) => string;
}

const DomainContext = createContext<DomainContextType>({
  mode: "default",
  showPrices: true,
  isReseller: false,
  getTranslationKey: (key) => key,
});

interface DomainProviderProps {
  children: ReactNode;
}

export const DomainProvider = ({ children }: DomainProviderProps) => {
  const getTranslationKey = (key: string): string => {
    // For reseller domain, try domain-specific key first
    // Components should check for the key with suffix, fallback to base key
    return domainConfig.isReseller ? `${key}_reseller` : key;
  };

  const value: DomainContextType = {
    mode: domainConfig.mode,
    showPrices: domainConfig.showPrices,
    isReseller: domainConfig.isReseller,
    getTranslationKey,
  };

  return (
    <DomainContext.Provider value={value}>{children}</DomainContext.Provider>
  );
};

export const useDomain = () => useContext(DomainContext);

export default DomainContext;

